export default __webpack_public_path__ + "static/media/19.654f2a91.jpg";